import yaml from 'js-yaml';
import { tagNetworkFailure, tagBodyReadFailure } from './lib/network-failure.js';

const cache = new Map();

export const getStorePackConfig = (url) => {

    if (cache.has(url)) {
        return Promise.resolve(cache.get(url));
    }

    return fetch(url, {
        method: 'GET',
    })
        .catch(tagNetworkFailure)
        .then((response) => response.text().catch(tagBodyReadFailure))
        .then((file) => {
            const types = {};

            // remove the unity tag line
            file = file.replace(/%TAG.+\r?\n?/, '');
            file = file.replace(/!u!([0-9]+).+/g, '');

            // create our schema    
            const schema = yaml.DEFAULT_SCHEMA.extend(Object.values(types));
            let config = yaml.load(file, null, schema);

            cache.set(url, config.MonoBehaviour);
            return config.MonoBehaviour;

        })
        .catch((error) => {
            console.error(error);
            // Same split as getStorePacks: only a rejection tagged at the fetch boundary or on
            // the body read is a dropped connection to S3 (Rollbar #379) — nothing to fix on
            // our side. A YAML parse failure or a handler bug stays at error level.
            if (error?.isNetworkFailure) {
                Rollbar.info("Get store pack config network failure: " + error);
            } else {
                Rollbar.error("Get store pack config error: " + error);
            }
        })
}
